export default __webpack_public_path__ + "static/media/coming-soon-coffee_cup.a56768f4.png";